import React from 'react';
import AppStore from '../../stores/AppStore';
import * as AppActions from '../../actions/AppActions';
import TemplateData, {
  localsMessages,
  guestLocalsMessages,
} from '../../utility/getTemplateData';
import PropTypes from 'prop-types';
import { showSpinnerOverlay, hideSpinnerOverlay } from '../../utility/helper';
import CancelAndReturn from '../../components/cancelAndReturn';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import DonateGiftAid from '../../guest-payment-components/DonateGiftAid';
import {
  normalizeNumber,
  formatCurrencyAsString,
} from '../../utility/formator';
import { withRouter } from 'react-router-dom';
import { observeUntilEventObserved } from '../../utility/helper';
import { fetcher } from '../../utility/domUtils';
import CVVComponent from '../../containers/cvv-component';
import withDonate from '../../components/guest/WithDonate';
import withTheme from '../../components/withTheme';
import ThreeDSContainer from '../../components/threeDS/ThreeDSContainer';
import { Alert, Button, BodyText, CaptionText } from '@paypalcorp/pp-react';
import getContent from 'pp-react-l10n';
import CloseButton from '../../components/CloseButton';
import BackButton from '../../components/BackButton';
import DonateHeader from '../../components/common/DonateHeader';
import PaymentInformation from './guestReviewComponents/PaymentInformation';
import CrossBorder from './guestReviewComponents/CrossBorder';
import FeePricing from './guestReviewComponents/FeePricing';
import {
  isExternalFlow,
  isPPUnlistedCampaign,
} from '../../utility/productIntegrationUtils';
import { isInContext } from '../../utility/inContextDonation';
import { trackErrorIM, trackLinkClick } from '../../fpti/fpti';
import { LINK_NAME, PAGE_SPEC } from '../../fpti/fptiConstants';

let giftAidText = localsMessages('common/giftAidIt');
const donateGiftPercentage = AppStore.getGiftAidItExtraAmount();
let giftAidTextObj = (giftAidText && giftAidText.giftAidIt) || {};
const guestMessages = guestLocalsMessages('guest/guestForm');
const messages = localsMessages('guest/crossBorder');

export const CURRENCY_CONVERSION_OPTIONS = {
  PAYPAL: 'PAYPAL',
  ISSUER: 'ISSUER',
};

class GuestReview extends React.Component {
  constructor(props) {
    super(props);

    let isRecurring = AppStore.getDonationRecurring() === 'checked';
    const stateConversionWithPayPal = this.getStateForConversionWithPayPal();

    this.state = {
      subHeaderLabel: TemplateData.donationName,
      donationId: AppStore.getSelectedProgram() || TemplateData.donationId,
      orgName: TemplateData.charityName,
      amountDecimalPoint: TemplateData.donationDecimalPoint || '.',
      decimalPoint: TemplateData.donationDecimalPoint || '.',
      isRecurring,
      ...stateConversionWithPayPal,
      showCVVField: false,
      securityCode: '',
      isCurrencyConversionModalOpen: false,
      selectedRecurringFrequency: AppStore.getSelectedRecurringFrequency(),
    };
    this.getFundingOptions = this.getFundingOptions.bind(this);
  }

  endCustomCPLTracking = () => {
    const spinnerOverlay = document.getElementById('spinnerOverlay');

    if (spinnerOverlay.style.display === 'none') {
      // From tesla flow we don't have the spinner
      window.PAYPAL.analytics.endCPLTracking({
        page: 'main:donate:wps:guest:crossBorder:web::',
        action: 'crossborder_page_loaded',
        uicomp: 'crossBorder',
        uitype: 'page',
      });
    } else {
      // From guest form we need to wait for the spinner to disappear
      observeUntilEventObserved(
        spinnerOverlay,
        { attributes: true },
        (observer) => {
          if (spinnerOverlay.style.display === 'none') {
            window.PAYPAL.analytics.endCPLTracking({
              page: 'main:donate:wps:guest:crossBorder:web::',
              action: 'crossborder_page_loaded',
              uicomp: 'crossBorder',
              uitype: 'page',
            });

            observer.disconnect();
            return;
          }
        }
      );
    }
  };

  componentDidMount() {
    this.endCustomCPLTracking();
  }

  getStateForConversionWithPayPal() {
    let fundingOptions = AppStore.getFundingOptions();
    let myData = AppStore.getAllData() || {};
    const cardType = _get(myData, 'cardSpec.cardSpec.type', '')
      .replace(/[.,_]|\s\(.*\)/g, '')
      .replace(/[\s_]/g, '-')
      .toLowerCase();
    let [fundingSources] = fundingOptions ? fundingOptions.sources : [];
    let paymentNetwork = fundingSources.payment_card.network.toLowerCase();
    paymentNetwork =
      paymentNetwork.charAt(0).toUpperCase() + paymentNetwork.slice(1);
    let paymentDigits = fundingSources.payment_card.last_4;
    let paymentType = (fundingSources?.payment_card?.type ?? '').toLowerCase();
    paymentType =
      paymentType && paymentType.charAt(0).toUpperCase() + paymentType.slice(1);
    let issuer = fundingSources.payment_card.issuer.name;
    let exchangeRate = parseFloat(
      fundingOptions.currency_conversion?.exchange_rate || '0.00'
    ).toString();
    let fundsIn = fundingOptions.currency_conversion?.funds_in || '0.00';
    let fundsOut = fundingOptions.currency_conversion?.funds_out || '0.00';
    let feeAmounts = fundingOptions.fee_amount || null;
    let amount = this.getLocalizedCurrency(
      fundingSources.payment_card.amount.value,
      fundingSources.payment_card.amount.currency
    );

    return {
      exchangeRate,
      paymentCard: `${paymentNetwork} x-${paymentDigits}`,
      paymentDigits,
      paymentType,
      source: fundingSources,
      issuerName: issuer,
      inAmount: fundsIn.value,
      inCurrency: fundsIn.currency,
      inSymbol: fundsIn.symbol,
      outAmount: fundsOut.value,
      outCurrency: fundsOut.currency,
      outSymbol: fundsOut.symbol,
      currencyConversionOption: CURRENCY_CONVERSION_OPTIONS.PAYPAL,
      cardType,
      feeAmounts,
      currencyConversion: fundingOptions.currency_conversion,
      fundingCode: !_isEmpty(fundingOptions.currency_conversion)
        ? 'CROSS_BORDER'
        : 'PAYER_FEE',
      currencyCode: fundingOptions.currencyCode,
      amount: _includes(amount, fundingSources.payment_card.amount.currency)
        ? `${amount}`
        : `${amount} ${fundingSources.payment_card.amount.currency}`,
    };
  }

  getStateForConversionWithIssuer() {
    let fundingOptions = AppStore.getFundingOptions();
    let [fundingSources] = fundingOptions ? fundingOptions.sources : [];
    let amount = this.getLocalizedCurrency(
      fundingSources.payment_card.amount.value,
      fundingSources.payment_card.amount.currency
    );
    let symbol = AppStore.getDonationSymbol();
    let currency = AppStore.getDonationCode();
    let feeAmounts = fundingOptions.fee_amount || null;

    // No currency_conversion. fundsIn and fundsOut will not be available.
    return {
      amount: _includes(amount, fundingSources.payment_card.amount.currency)
        ? `${amount}`
        : `${amount} ${fundingSources.payment_card.amount.currency}`,
      symbol,
      currency,
      currencyConversionOption: CURRENCY_CONVERSION_OPTIONS.ISSUER,
      currencyConversion: fundingOptions.currency_conversion,
      feeAmounts,
    };
  }

  updateFundingOptionsState() {
    let fundingOptions = AppStore.getFundingOptions();
    if (!fundingOptions.currency_conversion) {
      this.setState(this.getStateForConversionWithIssuer());
    } else {
      this.setState(this.getStateForConversionWithPayPal());
    }
  }

  getLocalizedCurrency = (amount, currency) => {
    let formatedAmount = {
      value: parseFloat(amount).toFixed(2),
      currency: currency,
    };
    let newAmount = formatCurrencyAsString(formatedAmount);
    return newAmount;
  };

  handleCurrencyConversionClick = () => {
    trackLinkClick(LINK_NAME.CURRENCY_CONVERSION, {
      pageSpec: PAGE_SPEC.CROSS_BORDER_PAGE,
    });
    this.showCurrencyConversionModal();
  };

  showCurrencyConversionModal = () => {
    this.setState({
      isCurrencyConversionModalOpen: true,
    });
  };

  hideCurrencyConversionModal = () => {
    this.setState({
      isCurrencyConversionModalOpen: false,
    });
  };

  handleDonateClick = () => {
    if (this.state.showCVVField) {
      const cvv = document.getElementById('securityCode').value;
      this.childCVVInfo.handleFieldBlur(
        cvv,
        'errorMessageCSC',
        'REQUIRED_SECURITY_CODE',
        'INVALID_SECURITY_CODE'
      );

      let hasError =
        document.getElementsByClassName('vx_has-error-with-message').length > 0;
      if (!cvv || hasError) {
        return;
      }
    }
    const fundingOptions = AppStore.getFundingOptions();
    const contingencies = _get(fundingOptions, 'contingencies') || [];
    const threeDSContingency =
      _find(contingencies, { action: '3D_SECURE_DATA_COLLECTION_REQUIRED' }) ||
      {};

    if (!_isEmpty(threeDSContingency)) {
      this.threeDSContainer.initializeThreeDS();
      return;
    }

    // All contingencies resolved
    this.processDonation();
  };

  processDonation = () => {
    showSpinnerOverlay();

    return this.props.doFulfilment({
      securityCode: this.state.securityCode,
    });
  };

  handleGiftAidOption = (giftAidState) => {
    AppActions.updateGiftaidItFlag({ giftAidItFlag: giftAidState });
  };

  updateGiftAidComponent = (state) => {
    const extraCostText = getContent('locals')('common/giftAidIt')(
      'giftAidIt.extraCost',
      {
        currency: state.outSymbol,
        amount: state.outAmount,
        extraAmount: (donateGiftPercentage * state.outAmount).toFixed(2),
      },
      {
        useHTML: true,
      }
    );

    let modalp1 = (giftAidTextObj && giftAidTextObj.modalp1) || '',
      modalp2 = (giftAidTextObj && giftAidTextObj.modalp2) || '',
      applyGiftAid = (giftAidTextObj && giftAidTextObj.applyGiftAid) || '';

    modalp1 = modalp1 && modalp1.replace('{orgName}', state.subHeaderLabel);
    modalp2 = modalp2 && modalp2.replace('{orgName}', state.subHeaderLabel);
    applyGiftAid =
      applyGiftAid && applyGiftAid.replace('{orgName}', state.subHeaderLabel);

    giftAidTextObj.extraCost = extraCostText;
    giftAidTextObj.modalp1 = modalp1;
    giftAidTextObj.modalp2 = modalp2;
    giftAidTextObj.applyGiftAid = applyGiftAid;
  };

  getFundingOptions(currencyConversionType) {
    let fundingOptions = AppStore.getFundingOptions();
    const fundingSources = fundingOptions.sources || [];
    const lastFundingSource = fundingSources[fundingSources.length - 1];
    const paymentCardId = _get(lastFundingSource, 'payment_card.id');

    return fetcher('/donate/guest/fundingOptions', {
      method: 'POST',
      body: JSON.stringify({
        amount: normalizeNumber(AppStore.getDonationAmount()),
        code: AppStore.getDonationCode(),
        fundingOptionId: AppStore.getFundingOptions().id,
        preferences: {
          currency_conversion: [
            {
              payment_card_id: paymentCardId,
              type: currencyConversionType,
              validity: 'TRANSACTION',
            },
          ],
        },
        consentShareAddress: AppStore.getShareAddress(),
        token: TemplateData.token,
        onboardingEnabled: TemplateData.onboardingEnabled,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log('getFundingOptions result :: ', result);

        // The funding options data format returned by the server is
        // different for ISSUER and PAYPAL. Handle it appropriately.

        // For conversion with 'ISSUER'
        if (currencyConversionType === CURRENCY_CONVERSION_OPTIONS.ISSUER) {
          fundingOptions = _get(result, 'data.fundingOpt[0]');
        } else {
          // For conversion with 'PAYPAL'
          fundingOptions = _get(result, 'fundingOpts[0]');
        }

        // Handle error case where fundingOptions call succeeds
        // but no data is returned
        if (_isEmpty(fundingOptions)) {
          trackErrorIM({
            errorCode: currencyConversionType,
            errorMessage: 'FUNDING_OPTIONS_EMPTY_CROSSBORDER',
          });
          this.props.history.push(
            `/donate/error/payment?token=${TemplateData.token}`
          );
          return;
        }

        // If CVV contingencies are present and has not been resolved,
        // then display cvv component
        const contingencies = _get(fundingOptions, 'contingencies');
        const hasCvvContingency = _find(contingencies, {
          action: 'CVV_REQUIRED',
        });
        const isCvvContingencyResolved = _get(
          result,
          'data.contingencyResolutionStatus.cvvContingencyResolved',
          false
        );

        this.setState({
          showCVVField: hasCvvContingency && !isCvvContingencyResolved,
        });

        // Updating store with funding options
        AppActions.updateFundingOptions({ fundingOptions });

        this.updateFundingOptionsState();

        console.log(result);
      })
      .catch(() => {
        console.log('FAILED');
        this.props.history.push(
          `/donate/error/payment?token=${TemplateData.token}`
        );
      })
      .finally(() => {
        hideSpinnerOverlay();
      });
  }

  handleSecurityCodeChange = (securityCode) => {
    this.setState({
      securityCode: securityCode,
    });
  };

  handleThreeDSStepUpAuthSuccess = () => {
    this.props.toggleSpinner(true);
    this.props.doFulfilment({
      securityCode: this.state.securityCode,
    });
  };

  handleThreeDSStepUpAuthFailure = () => {
    // Unrecoverable error !!
    this.props.history.push('/donate/error/payment');
  };

  handleThreeDSFailure = () => {
    // Unrecoverable error !!
    this.props.history.push('/donate/error/threeDS');
  };

  render() {
    const inAmount = this.getLocalizedCurrency(
      this.state.inAmount,
      this.state.inCurrency
    );
    const outAmount = this.getLocalizedCurrency(
      this.state.outAmount,
      this.state.outCurrency
    );
    const fundsIn = _includes(inAmount, this.state.inCurrency)
      ? `${inAmount}`
      : `${inAmount} ${this.state.inCurrency}`;
    const fundsOut = _includes(outAmount, this.state.outCurrency)
      ? `${outAmount}`
      : `${outAmount} ${this.state.outCurrency}`;

    const getRecurringLabel = () => {
      const donateNowRec = _get(guestMessages, 'guestLabels.donateNowRec');
      switch (this.state.selectedRecurringFrequency) {
        case 'Week':
          return donateNowRec.weekly;
        case 'Month':
          return donateNowRec.monthly;
        case 'Year':
          return donateNowRec.yearly;
        default:
          return donateNowRec.monthly;
      }
    };

    const { label = {} } = messages || {};
    let donateNowRecurring = getRecurringLabel();
    donateNowRecurring =
      donateNowRecurring && donateNowRecurring.replace('{amount}', fundsOut);

    let giftaidFlag = AppStore.getGiftaidItFlagStatus();
    this.updateGiftAidComponent(this.state);

    let { csc: cscLabel, cscwarning } = guestMessages.guestLabels;
    cscwarning =
      cscwarning && cscwarning.replace('{csc}', cscLabel.toLowerCase());

    const { showCVVField } = this.state;

    return (
      <div
        className={`${
          TemplateData.bannerUrl ? 'gn_donate_wrapper' : 'donate_wrapper'
        } ${isInContext() ? 'context_gn_wrapper' : ''}`}
      >
        <DonateHeader />

        {showCVVField && (
          <div className="ppvx_row alert-container mb-8">
            <Alert type="warning">{cscwarning}</Alert>
          </div>
        )}
        {isExternalFlow() && (
          <>
            <BackButton inverse />
            <CloseButton inverse />
          </>
        )}

        <div id="crossBorderContainer" className="cross-border">
          {TemplateData.isGiftaiditEnabled && (
            <DonateGiftAid
              isAlreadyEnrolled={giftaidFlag}
              showAddress={false}
              addressData=""
              isChecked={giftaidFlag}
              handleGiftAidOption={this.handleGiftAidOption}
              contentMsg={giftAidTextObj}
            />
          )}

          <div className="ppvx_row">
            <div className="ppvx_col-12">
              <BodyText style={{ margin: '28px 0' }}>
                {label.donatingFrom}
              </BodyText>
            </div>
          </div>

          <PaymentInformation
            fundingOptions={AppStore.getFundingOptions()}
            paymentDigits={this.state.paymentDigits}
            paymentType={this.state.paymentType}
            source={this.state.source}
            issuer={this.state.issuerName}
            isPaypalCurrencyConversion={
              this.state.currencyConversionOption ===
              CURRENCY_CONVERSION_OPTIONS.PAYPAL
            }
            funds={this.state.amount}
            cardType={this.state.cardType}
          />

          {showCVVField && (
            <CVVComponent
              onRef={(ref) => (this.childCVVInfo = ref)}
              handleSecurityCodeChange={this.handleSecurityCodeChange}
            />
          )}

          {isPPUnlistedCampaign() && !_isEmpty(this.state.feeAmounts) && (
            <FeePricing
              feeAmounts={this.state.feeAmounts}
              getLocalizedCurrency={this.getLocalizedCurrency}
            />
          )}

          {this.state.fundingCode === 'CROSS_BORDER' && (
            <CrossBorder
              hasFees={!_isEmpty(this.state.feeAmounts)}
              isPaypalCurrencyConversion={
                this.state.currencyConversionOption ===
                CURRENCY_CONVERSION_OPTIONS.PAYPAL
              }
              funds={
                this.state.currencyConversionOption ===
                CURRENCY_CONVERSION_OPTIONS.PAYPAL
                  ? fundsIn
                  : this.state.amount
              }
              getFundingOptions={this.getFundingOptions}
              currencyConversionOption={this.state.currencyConversionOption}
              getLocalizedCurrency={this.getLocalizedCurrency}
              setSelectedOption={(currencyConversionType) =>
                this.setState({
                  currencyConversionOption: currencyConversionType,
                })
              }
              stateCurrency={{
                inCurrency: this.state.inCurrency,
                exchangeRate: this.state.exchangeRate,
                amountDecimalPoint: this.state.amountDecimalPoint,
                inSymbol: this.state.inSymbol,
                outCurrency: this.state.outCurrency,
              }}
            />
          )}

          <div className="legal-text text-center">
            <CaptionText>
              {getContent('locals')('guest/crossBorder')(
                'label.policies',
                { country: TemplateData.country },
                { useHTML: true }
              )}
            </CaptionText>
          </div>

          <div className="text-center">
            <Button
              className="btn-wide"
              id="donate-button"
              disabled={this.props.disabled}
              onClick={this.handleDonateClick}
            >
              {this.state.isRecurring ? donateNowRecurring : label.donatenow}
            </Button>
          </div>
          <div className="cross-border-cancel-return">
            <CancelAndReturn />
          </div>

          <ThreeDSContainer
            onThreeDSStepUpAuthNotRequired={this.handleThreeDSStepUpAuthSuccess}
            onThreeDSStepUpAuthSuccess={this.handleThreeDSStepUpAuthSuccess}
            onThreeDSStepUpAuthFailure={this.handleThreeDSFailure}
            onThreeDSFailure={this.handleThreeDSFailure}
            onRef={(ref) => (this.threeDSContainer = ref)}
          />
        </div>
      </div>
    );
  }
}

GuestReview.propTypes = {
  doFulfilment: PropTypes.func,
  history: PropTypes.object,
  toggleSpinner: PropTypes.func,
  disabled: PropTypes.bool,
};

export default withRouter(withDonate(withTheme(GuestReview)));
